var React = require('react');

function Checkbox (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#55FF8A","fillOpacity":".1","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 8a1 1 0 0 1 0 1.414l-8 8-4-4A1 1 0 1 1 7.414 12L10 14.586 16.586 8A1 1 0 0 1 18 8z","fill":"#55FF8A","key":1})]);
}

Checkbox.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Checkbox;

Checkbox.default = Checkbox;
